<template>
  <div
    class="custom-edit-media-extend-oparea-box fn-inline"
    @click="handleSelectBoxClick"
    :style="{
      '--transLeft': `${renderData.transLeft}px`,
      '--extendRenderWidth': `${renderPlayerData.config?.extendRenderWidth}px`,
    }"
  >
    <div class="custom-edit-media-tag-box"></div>
    <div class="custom-edit-media-oparea">
      <div class="custom-edit-media-waves-loading" v-if="renderData.loading">
        <template v-for="(item, index) in 8" :key="index">
          <div
            class="custom-edit-media-waves-loading-wave-bar block fn-inline"
          ></div>
        </template>
      </div>
      <div class="custom-edit-media-waves-box" v-if="!renderData.loading">
        <div
          class="custom-edit-media-waves-box-render fn-inline"
          ref="refSelectBox"
        >
          <AudioWaveRender
            :renderBoxSize="renderData.renderBoxSize"
            :config="renderPlayerData.config"
            :waveBarData="renderData.renderWavebarData"
            :activeIndex="renderData.activeIndex"
            :slecteAreaIndex="{
              startIndex: renderData.selectStartIndex,
              endIndex: renderData.selectEndIndex,
            }"
          ></AudioWaveRender>
          <!-- <template
            v-for="(item, index) in renderData.renderWavebarData"
            :key="index"
          >
            <div
              class="custom-edit-media-wave-item"
              :class="{
                'cemwi-active': renderData.activeIndex >= index,
                'cemwi-selected': renderData.selectStartIndex <= index,
              }"
              :style="{
                height: item + 'px',
              }"
            ></div>
          </template> -->
        </div>
        <!-- <div class="custom-edit-media-waves-box-extend fn-inline"></div> -->
      </div>
    </div>
    <div
      class="custom-edit-media-position-box"
      :style="{
        '--positionLeft': `${positionLeft}px`,
      }"
    >
      <div class="custom-edit-media-position-box-position"></div>
    </div>
    <div
      class="custom-edit-media-oparea-op-box"
      v-if="!props.disableForwardSelect"
      :class="{
        'custom-edit-media-oparea-op-disabled': props.disableForwardSelect,
      }"
    >
      <div class="custom-edit-media-op-start">
        <div class="custom-edit-media-op-se pointer" ref="refDragSelectStart">
          <i class="fn-inline"> </i>
          <i class="fn-inline c"> </i>
          <i class="fn-inline"> </i>
          <div class="custom-edit-media-op-curtime">
            {{ mediaUtil.formatTime(renderData.regenerateStartTime) }}
          </div>
        </div>
      </div>
      <div class="custom-edit-media-op-end">
        <div class="custom-edit-media-op-se" ref="refDragSelectEnd">
          <i class="fn-inline"> </i>
          <i class="fn-inline c"> </i>
          <i class="fn-inline"> </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
import AudioWaveRender from "@/components/media/audioPlayer/AudioWaveRender.vue";
import globalConfig, { chinaAppName } from "@/config/config.js";

import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue";
import mediaUtil from "@/components/media/utils/utils.js";
import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js";
import tools from "@/utils/tools.js";
import clipUtil from "@/components/media/utils/clipUtil.js";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext;
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const defaultConfig = {
  spacingSize: 3,
  wavebarWidth: 2,
  allowForward: true,
  minSelectTime: 0,
  defaultSelectTime: 0,
  endClipTime: 0,
};
const props = defineProps({
  config: {
    type: Object,
    default: () => {
      return {
        spacingSize: 3,
        wavebarWidth: 2,
        allowForward: true,
        minSelectTime: 0,
        defaultSelectTime: 0,
        extendRenderWidth: 0, //  100,
      };
    },
  },
  url: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 0,
  },
  waveformData: {
    type: Array,
    default: () => {
      return [];
    },
  },
  disableForwardSelect: {
    type: Boolean,
    default: true, // tools.isProd(),
  },
  // sourceData: {
  //   type: Object,
  //   default: () => {
  //     return {
  //       sourceTotalDuration: 0,
  //       url: "",
  //       decodeData: null,
  //     };
  //   },
  // },
});
const emits = defineEmits([
  "syncPlayState",
  "syncProgress",
  "syncWaveLoadingState",
]);
const refSelectBox = ref(null);
const refDragSelectEnd = ref(null);
const refDragSelectStart = ref(null);
const stateData = {
  sourceTotalDuration: 0,
  backExtensionDuration: 0,
  sourceTotalWidth: 0,
  waveBoxWidth: 0,
  selectStartIndex: 0,
  selectEndIndex: 0,
};
const renderData = reactive({
  isPlaying: false,
  progress: 0,
  duration: props.duration,
  startTime: 0,
  endTime: 0,

  activeIndex: 0,
  selectStartIndex: 0,
  selectEndIndex: 0,

  renderWavebarData: [],
  transLeft: 0,
  regenerateStartTime: 0,
  loading: false,

  renderBoxSize: {
    width: 0,
    height: 0,
  },
});
const renderPlayerData = reactive({
  decodeData: null,
  totalDuration: 0,
});

const positionLeft = computed(() => {
  return renderData.progress * renderPlayerData.waveBarBoxRenderWidth;
});

const globalAudioPlayerData = {
  curPlayerData: null,
};

const doTogglePlay = async () => {
  if (renderData.isPlaying) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(globalAudioPlayerData.curPlayerData?.url);
  } else {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(globalAudioPlayerData.curPlayerData?.url, false);
  }
};
const handleSelectBoxClick = (e) => {
  if (renderData.loading) {
    return;
  }
  const { width, left } = refSelectBox.value.getBoundingClientRect();
  const clientX = e.clientX;
  if (clientX < left + width) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(
      globalAudioPlayerData.curPlayerData?.url,
      (clientX - left) / width
    );
  }
};
const doSetPlayeData = async () => {
  // globalAudioPlayerData.clipDecodeData = await clipUtil.clipdDecodeData(stateData.decodeData, renderPlayerData.startTime, renderPlayerData.endTime)
  // const exportData = await clipUtil.decodeDataToUrl(stateData.decodeData);
  const url = props.url;
  if (globalAudioPlayerData.curPlayerData !== null) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(globalAudioPlayerData.curPlayerData);
  }
  if (stateData.mounted) {
    const { endClipTime } = renderPlayerData.config;
    globalAudioPlayerData.curPlayerData = appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
      url,
      {
        duration: renderData.duration ?? 0,
        clipStart: 0,
        clipEnd: (renderData.duration ?? 0) - endClipTime,
        listeners: {
          onDurationChange({
            duration,
            durationTime,
            sourceDuration,
            sourceDurationTime,
          }) {
            renderData.duration = duration;
          },
          onPlayStateChange(isPlaying) {
            renderData.isPlaying = isPlaying;
          },
          onLoadingStateChange(isLoading) {},
          onPositionChange: (obj) => {
            // console.log("onPositionChange", obj)
            const { progress, currentTime, endTime } = obj;
            renderData.startTime = currentTime;
            renderData.endTime = endTime;
            renderData.progress = progress;
            renderData.activeIndex = Math.floor(
              progress * renderData.renderWavebarData.length
            );
          },
        },
      }
    );
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(globalAudioPlayerData.curPlayerData?.url, false);
  }
};

const setRenderWaveData = async () => {
  const {
    spacingSize,
    wavebarWidth,
    allowForward,
    minSelectTime,
    defaultSelectTime,
    endClipTime,
  } = renderPlayerData.config;
  renderPlayerData.waveBarCount = Math.floor(
    (renderPlayerData.waveBarBoxRenderWidth + spacingSize) /
      (spacingSize + wavebarWidth)
  );
  let wavebarData = [];
  if (props.waveformData?.length) {
    wavebarData = clipUtil.getWaveDataByWaveFormData(
      props.waveformData,
      renderPlayerData.waveBarCount
    );
  } else {
    if (props.url) {
      try {
        wavebarData = await clipUtil.getWaveDataByUrl(
          props.url,
          renderPlayerData.waveBarCount,
          endClipTime
        );
      } catch (e) {
        wavebarData = Array.from(
          { length: renderPlayerData.waveBarCount },
          () => Math.random()
        );
      }
    } else {
      wavebarData = Array.from({ length: renderPlayerData.waveBarCount }, () =>
        Math.random()
      );
    }
  }
  const wavebarPainterData = clipUtil.fixedPaintHarfHeightWaveBarData(
    wavebarData,
    30
  );
  renderData.renderWavebarData = wavebarPainterData;
};
const setRenderSelectData = async () => {
  const {
    spacingSize,
    wavebarWidth,
    clipDuration,
    allowForward,
    minSelectTime,
    defaultSelectTime,
  } = renderPlayerData.config;

  const width = renderPlayerData.waveBarBoxRenderWidth;
  const duration = renderData.duration;
  if (duration > defaultSelectTime) {
    renderData.transLeft = width - (defaultSelectTime / duration) * width;
  } else {
    renderData.transLeft = 0;
  }
  if (duration > minSelectTime) {
    renderPlayerData.maxTransLeft = Math.max(
      0,
      Math.min(width - (minSelectTime / duration) * width, width)
    );
  } else {
    renderPlayerData.maxTransLeft = width;
  }
  renderData.regenerateStartTime = (renderData.transLeft / width) * duration;
  renderData.regenerateStartTime = Math.max(
    0,
    Math.min(renderData.regenerateStartTime, renderData.duration)
  );

  renderData.selectStartIndex = Math.floor(
    (renderData.transLeft / width) * renderData.renderWavebarData.length
  );
  renderData.selectEndIndex = renderData.renderWavebarData.length - 1;
};
const doSetRegenerateData = (isEnd) => {
  const width = renderPlayerData.waveBarBoxRenderWidth;

  renderData.selectStartIndex = Math.floor(
    (renderData.transLeft / width) * renderData.renderWavebarData.length
  );
  renderData.selectEndIndex = renderData.renderWavebarData.length - 1;
  renderData.regenerateStartTime =
    (renderData.transLeft / width) * renderData.duration;
  renderData.regenerateStartTime = Math.max(
    0,
    Math.min(renderData.regenerateStartTime, renderData.duration)
  );

  if (isEnd) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(
      globalAudioPlayerData.curPlayerData?.url,
      renderData.transLeft / width
    );
    if (!renderData.isPlaying) {
      doTogglePlay();
    }
  }
};

const initConfig = () => {
  renderPlayerData.config = Object.assign({}, defaultConfig, props.config, {
    extendRenderWidth: 0, // createRenderType.value == "mobile" ? 60 : 100,
  });
};
// 初始化操作
const init = async (url) => {
  return new Promise((resolve, reject) => {
    try {
      renderPlayerData.waveBarBoxInfo =
        refSelectBox.value.getBoundingClientRect();
      renderData.loading = true;
      nextTick(async () => {
        renderData.renderBoxSize = {
          width: renderPlayerData.waveBarBoxInfo.width,
          height: renderPlayerData.waveBarBoxInfo.height,
        };
        renderPlayerData.waveBarBoxRenderWidth =
          renderPlayerData.waveBarBoxInfo.width;
        renderData.duration = props.duration;
        await setRenderWaveData();
        await setRenderSelectData();
        nextTick(async () => {
          if (!stateData.mounted) return;
          await doSetPlayeData();
          stateData.renderWavebarReady = true;
          renderData.loading = false;
          doTogglePlay();
          resolve();
        });
      });
    } catch (e) {
      reject(e);
    }
  });
};
const initEvent = () => {
  if (props.disableForwardSelect) return;
  stateData.touchSwipeState = false;

  let transLeft = 0;

  stateData.registTouchWaveBarSwipeCall = tools.registTouchSwipe(
    refDragSelectStart.value,
    {
      direction: "horizontal",
      startCb: (e, actionData) => {
        if (!stateData.touchSwipeState) {
          stateData.touchSwipeState = true;
          transLeft = renderData.transLeft;
        }
      },
      moveCb: (e, actionData) => {
        const { startX, endX } = actionData;
        const dx = Math.floor(endX - startX);
        const { width } = renderPlayerData.waveBarBoxInfo;
        let newTransLeft = transLeft + dx;
        newTransLeft = Math.max(
          0,
          Math.min(newTransLeft, renderPlayerData.maxTransLeft)
        );
        renderData.transLeft = newTransLeft;
        doSetRegenerateData();
      },
      endCb: (e, actionData) => {
        if (stateData.touchSwipeState) {
          stateData.touchSwipeState = false;
          doSetRegenerateData(true);
        }
      },
    }
  );
};
watch(
  () => renderData.isPlaying,
  (newValue) => {
    emits("syncPlayState", renderData.isPlaying);
  }
);
watch(
  () => renderData.progress,
  (newValue) => {
    emits("syncProgress", renderData.progress, renderData.startTime);
  }
);
watch(
  () => renderData.duration,
  (newValue) => {
    emits("syncDuration", renderData.duration);
  }
);

watch(
  () => renderData.loading,
  (newValue) => {
    emits("syncWaveLoadingState", renderData.loading);
  }
);

onMounted(() => {
  stateData.mounted = true;
  initConfig();
  nextTick(async () => {
    await init(props.url);
    await initEvent();
  });
});

onUnmounted(() => {
  stateData.mounted = false;
  if (globalAudioPlayerData.curPlayerData) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(globalAudioPlayerData.curPlayerData);
  }
});

onBeforeUnmount(() => {
  stateData.registTouchWaveBarSwipeCall?.();
});

defineExpose({
  togglePlay: doTogglePlay,
  getRenerateStartTime: () => {
    return renderData.regenerateStartTime;
  },
});
</script>
<style lang="scss">
@keyframes audio-waveform-bar-animation {
  0% {
    transform: scaleY(1);
    opacity: 1;
  }
  50% {
    transform: scaleY(5);
    opacity: 1;
  }
  100% {
    transform: scaleY(1);
    opacity: 1;
  }
}
.custom-edit-media-extend-oparea-box {
  position: relative;
  width: 100%;
  .custom-edit-media-oparea {
    height: 80px;
  }
  .custom-edit-media-waves-loading {
    height: 80px;
    width: 100%;
    text-align: center;
    line-height: 80px;
    .custom-edit-media-waves-loading-wave-bar {
      width: 2px;
      height: 2px;
      background: #d282ff;
      margin: 0 5px;
      animation: audio-waveform-bar-animation 0.5s infinite;
      animation-timing-function: cubic-bezier(0.43, 0.04, 0.51, 0.94);
    }
    @for $i from 1 through 8 {
      .custom-edit-media-waves-loading-wave-bar:nth-child(#{$i}) {
        animation-delay: #{($i - 1) * 0.05}s;
      }
    }
  }
  .custom-edit-media-waves-box {
    height: 80px;
    .custom-edit-media-waves-box-render {
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - var(--extendRenderWidth));
    }
    .custom-edit-media-waves-box-extend {
      height: 80px;
      width: var(--extendRenderWidth);
    }
    .custom-edit-media-wave-item {
      width: 2px;
      background: #ffffff;
      &.cemwi-active {
        background: #d282ff;
      }
      &.cemwi-selected {
        background: rgba(255, 233, 94, 0.5);
      }
    }
  }
  .custom-edit-media-position-box {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    right: var(--extendRenderWidth);
    display: none;
    .custom-edit-media-position-box-position {
      background: #fff;
      position: absolute;
      top: 0;
      height: 100%;
      width: 1px;
      left: var(--positionLeft);
    }
  }
  .custom-edit-media-oparea-op-box {
    position: absolute;
    border: 1px solid #94adff;
    height: 100%;
    top: 0px;
    right: 0px;
    left: var(--transLeft);
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0 12px 12px 0;
    cursor: auto;
    .custom-edit-media-op-start,
    .custom-edit-media-op-end {
      width: 0px;
      height: calc(100% + 2px);
      margin-top: -1px;
      .custom-edit-media-op-se {
        background: #94adff;
        width: 16px;
        height: 100%;
        line-height: 80px;
        text-align: center;
        position: relative;
        opacity: 1;
        display: block;
      }
      i {
        width: 2px;
        height: 16px;
        background: #000000;
      }
      i.c {
        margin: 0 1px;
      }
      .custom-edit-media-op-curtime {
        position: absolute;
        left: -12px;
        top: -25px;
        font-family: HarmonyOS Sans SC;
        font-size: 12px;
        font-weight: normal;
        line-height: 20px;
        color: #ffffff;
        bacgkground: rgba(0, 0, 0, 0.5);
        padding: 0 4px;
        border-radius: 4px;
        background: rgba(148, 173, 255, 0.5);
        display: none;
      }
      .custom-edit-media-op-se:hover {
        .custom-edit-media-op-curtime {
          display: block;
        }
      }
    }
    .custom-edit-media-op-start {
      position: absolute;
      left: -8px;
    }
    .custom-edit-media-op-end {
      position: absolute;
      right: -8px;
      display: none;
    }
    &.custom-edit-media-oparea-op-disabled {
      .custom-edit-media-op-se {
        display: none;
      }
    }
  }
}
</style>
